// extracted by mini-css-extract-plugin
module.exports = {"container":"App_container__2virw","loaderContainer":"App_loaderContainer__2VWnY","loader":"App_loader__30NgK"};